module.exports = __webpack_public_path__ + "img/Pista_19_I.2cc84640.png";